<div class="col-md-12 mobile-display-view" style="padding-top: 15px;">
  <div class="game-highlight-wrap" style="background: #fff; padding: 15px; border-radius: 5px;" *ngIf="tip">
    <div style="margin-bottom: 20px;">
      <a routerLink="/tips" style="color: #2789ce; text-decoration: none; font-size: 14px;">
        <i class="fa fa-arrow-left"></i> Back to Tips & Previews
      </a>
    </div>
    
    <div class="card" style="border: 1px solid #c8ced3; border-radius: 5px;">
      <div class="card-body" style="padding: 20px;">
        <h3 class="card-title" style="margin-bottom: 10px;">{{ tip.title }}</h3>
        <h6 class="card-subtitle mb-3 text-muted" style="font-size: 12px; border-bottom: 1px solid #eee; padding-bottom: 10px;">{{ tip.date }}</h6>
        <p class="card-text" style="font-size: 14px; line-height: 1.6; margin-bottom: 15px;">
          <strong>{{ tip.summary }}</strong>
        </p>
        <p class="card-text" style="font-size: 14px; line-height: 1.6;">
          {{ tip.content }}
        </p>
      </div>
    </div>
  </div>
  
  <div class="game-highlight-wrap" style="background: #fff; padding: 15px; border-radius: 5px;" *ngIf="!tip">
    <h3 style="margin-bottom: 15px;">Article not found</h3>
    <a routerLink="/tips" class="btn btn-primary" style="background-color: #2789ce; border-color: #2789ce; color: white;">Return to list</a>
  </div>
</div>
